#import './TwilioMessageFields.graphql'

fragment LatestChatMessage on Chat {
  latestMessage {
    ...TwilioMessageFields
  }
  isUnread
}
